export default __webpack_public_path__ + "static/assets/med_pill_round_in_L1_solid_x_01_f.ebe96c60.png";